import React  from "react";
import ModuleTable from "./components/ModuleTable";
import { connect } from "react-redux";

const Modules = () => {
	
	return (
	    <div>
	      <div className="mt-5 grid h-full grid-cols-1 gap-4">      		
	      	<ModuleTable/>
	      	
	      </div>
	    </div>
    );
};

const mapStateToProps = (state) => ({
  
});

const mapDispatchToProps = (dispatch) => ({

});

export default connect(mapStateToProps, mapDispatchToProps)(Modules);